import React, { useState } from 'react';
import Datetime from 'react-datetime';
import { css } from 'glamor';
import * as theme from '../theme';
import { Label } from './Label';
import { InlineError } from './InputInlineError';
import calendarIcon from '../icons/calendar.svg';
import 'react-datetime/css/react-datetime.css';

export function DateTimeInput({
  label,
  value,
  onChange,
  error,
  floatPicker,
  displayFormat = 'yyyy-MM-dd HH:mm',
  ...props
}) {
  const [focused, setFocused] = useState(false);

  const inputStyle = {
    display: 'block',
    width: '100%',
    background: theme.white,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.gray10,
    borderRadius: 6,
    height: 60,
    fontSize: 22,
    paddingLeft: 16,
    paddingRight: 16,
    marginBottom: 16,
    transition: theme.transitionSnappy,
    '::placeholder': { color: theme.gray20 },
    ':focus': { outline: 'none' },
    ':disabled': { opacity: 0.5 },
  };

  const focusedStyles = focused && {
    borderColor: theme.blue,
  };

  const errorStyle = !!error && {
    color: theme.flavours.danger.foregroundColor,
    borderColor: theme.flavours.danger.highlightColor,
  };

  const wrapperStyle = css({
    position: 'relative',
    '.rdtPicker': {
      position: floatPicker ? 'absolute' : 'static',
      top: floatPicker ? 64 : 'auto',
      left: floatPicker ? 16 : 'auto',
      zIndex: 99,
      backgroundColor: theme.white,
      border: `1px solid ${theme.gray10}`,
      borderRadius: 6,
      padding: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    '.rdtTimeToggle': { display: 'none' },
    '.rdtTime td': { fontSize: 16 },
    '.rdtCounter': { fontSize: 16 },
  });

  const iconStyle = css({
    position: 'absolute',
    top: '50%',
    right: 16,
    transform: 'translateY(-50%)',
    pointerEvents: 'none',
  });

  return (
    <div className={wrapperStyle}>
      {label && <Label error={error}>{label}</Label>}
      <div className={css({ position: 'relative' })}>
        <img className={iconStyle} src={calendarIcon} alt="" />
        <Datetime
          utc={false}
          value={value}
          onChange={onChange}
          dateFormat="YYYY-MM-DD"
          timeFormat="HH:mm"
          inputProps={{
            readOnly: true,
            placeholder: 'Select date and time',
            className: css(inputStyle, focusedStyles, errorStyle),
            onFocus: () => setFocused(true),
            onBlur: () => setFocused(false),
          }}
          {...props}
        />
      </div>
      {error && <InlineError error={error} />}
    </div>
  );
}
